import WisdomNavbar from "components/navbars/WisdomNabvar";
import { useAuth } from "context/AuthContext";
import { useLanguage } from "context/LanguageContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWisdomRelatedSchools, fetchWisdomSubjects } from "services/wisdom/wisdomData";
import { postCreateGradeBook } from "services/wisdom/wisdomPms";

const name_list = [
    "الوحدة الأولى",
    "الوحدة الثانية",
    "الوحدة الثالثة",
    "الوحدة الرابعة",
    "الوحدة الخامسة",
    "الوحدة السادسة",
    "الوحدة السابعة",
    "الوحدة الثامنة",
    "الوحدة التاسعة",
    "الوحدة العاشرة",
    "اختبار منتصف العام",
    "اختبار نهاية العام"
]

const WisdomCreateGradeBook = () => {
    const { userInfo } = useAuth();
    const navigate = useNavigate();
    const { language } = useLanguage();
    const [schools, setSchools] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [filteredSubjects, setFilteredSubjects] = useState([]);
    const [form, setForm] = useState({
        name: "",
        type: "",
        category: "",
        max_score: "",
        subject_id: (userInfo?.organization_id === 13 || (userInfo?.user_role === "Teacher" && userInfo?.teacher_subject?.length > 1)) ? "" : userInfo?.teacher_subject[0]?.id,
        organization_id: userInfo?.organization_id === 13 ? "" : userInfo?.organization_id,
        start_date: "",
        end_date: ""
    });

    useEffect(() => {
        const loadSchools = async () => {
            const response = await fetchWisdomRelatedSchools();
            setSchools(response);
        };

        const loadSubjects = async () => {
            const response = await fetchWisdomSubjects();
            setSubjects(response);
            setFilteredSubjects(response);
        };

        loadSchools();
        if (userInfo?.organization_id === 13) {
            loadSubjects();
        } else if (userInfo?.user_role === "Teacher" && userInfo?.teacher_subject?.length > 1) {
            setSubjects(userInfo?.teacher_subject);
            setFilteredSubjects(userInfo?.teacher_subject);
        }
    }, [userInfo]);

    useEffect(() => {
        if (!userInfo) return;

        setForm((p) => ({
            ...p,
            subject_id: (userInfo?.organization_id === 13 || (userInfo?.user_role === "Teacher" && userInfo?.teacher_subject?.length > 1)) ? "" : userInfo?.teacher_subject[0]?.id,
            organization_id: userInfo.organization_id === 13 ? "" : userInfo.organization_id,
        }));
    }, [userInfo]);

    useEffect(() => {
        const filterSubjects = () => {
            const filtering = subjects.filter(subject => {
                const matchesSchools =
                    form.organization_id === ""
                        ? true
                        : subject.organizations.some(
                            org => org.id === Number(form.organization_id)
                        );

                return matchesSchools;
            });
            setFilteredSubjects(filtering);
        }

        if (userInfo?.organization_id === 13) filterSubjects();
    }, [form.organization_id, userInfo]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...form,
            category: form.category,
            exam_score: Number(form.exam_score),
            subject_id: Number(form.subject_id),
            organization_id: Number(form.organization_id),
        };

        await postCreateGradeBook(payload);
        navigate('/pms');
    };

    return (
        <div className="w-full min-h-screen bg-gray-50">
            <WisdomNavbar />

            <div className="max-w-xl mx-auto px-4 py-8" dir={language ? "ltr" : "rtl"}>
                <div className="bg-white rounded-2xl shadow p-6">
                    <h1 className="text-2xl font-bold text-gray-800 mb-6">
                        {language ? "Create Gradebook" : "انشاء سجل تقييم"}
                    </h1>

                    <form onSubmit={handleSubmit} className="space-y-5">
                        {/* School */}
                        {userInfo?.organization_id === 13 && <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "School" : "مدرسة"}
                            </label>
                            <select
                                value={form.organization_id}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, organization_id: e.target.value }))
                                }
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select school" : "اختر مدرسة"}
                                </option>
                                {schools.map((s) => (
                                    <option key={s.id} value={s.id}>
                                        {s.name}
                                    </option>
                                ))}
                            </select>
                        </div>}

                        {/* Name */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Gradebook Name" : "اسم سجل التقييم"}
                            </label>
                            <select
                                value={form.name}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, name: e.target.value }))
                                }
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select gradebook" : "اختر سجل التقييم"}
                                </option>
                                {name_list.map((s) => (
                                    <option key={s} value={s}>
                                        {s}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Type */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Type" : "النوع"}
                            </label>
                            <select
                                value={form.type}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, type: e.target.value }))
                                }
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select type" : "اختر النوع"}
                                </option>
                                <option value="اختبار تكويني">اختبار تكويني</option>
                                <option value="اختبار تجميعي">اختبار تجميعي</option>
                                <option value="مشروع تخرج">مشروع تخرج</option>
                            </select>
                        </div>

                        {/* category */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Category" : "تصنيف"}
                            </label>
                            <select
                                value={form.category}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, category: e.target.value }))
                                }
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select category" : "اختر التصنيف"}
                                </option>
                                <option value="theory">نظري</option>
                                <option value="practical">عملي</option>
                            </select>
                        </div>

                        {/* Exam Score */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Exam Total Score" : "درجة الكلية للاختبار"}
                            </label>
                            <input
                                type="number"
                                step="1"
                                value={form.max_score}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, max_score: e.target.value }))
                                }
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            />
                        </div>

                        {/* Subject */}
                        {(userInfo?.organization_id === 13 || (userInfo?.user_role === "Teacher" && userInfo?.teacher_subject?.length > 1)) && <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Subject" : "المادة"}
                            </label>
                            <select
                                value={form.subject_id}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, subject_id: e.target.value }))
                                }
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select subject" : "اختر المادة"}
                                </option>
                                {filteredSubjects.map((sub) => (
                                    <option key={sub.id} value={sub.id}>
                                        {sub.name}
                                    </option>
                                ))}
                            </select>
                        </div>}

                        {/* Start Date */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Start Date" : "تاريخ البداية"}
                            </label>
                            <input
                                type="date"
                                value={form.start_date}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, start_date: e.target.value }))
                                }
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            />
                        </div>

                        {/* End Date */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "End Date" : "تاريخ النهاية"}
                            </label>
                            <input
                                type="date"
                                value={form.end_date}
                                min={form.start_date || undefined}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, end_date: e.target.value }))
                                }
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            />
                        </div>

                        {/* Submit */}
                        <button
                            type="submit"
                            className="w-full py-2 rounded-xl bg-watomsBlue text-white hover:opacity-90 transition"
                        >
                            {language ? "Create Gradebook" : "انشاء سجل تقييم"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default WisdomCreateGradeBook;